<template>
    <tr>
        <td>
            {{ partition.name }}
            <div class="items" v-if="partition.grouped_partitions">
                <div class="item" v-for="grouped_partition in partition.grouped_partitions">
                    {{ grouped_partition.name }}
                </div>
            </div>
        </td>
        <td>
            <span style="font-weight: bold;font-size: 1.1em;">
                <!-- 起始： -->
                {{ $t('models.attributes.partitions.numbers_from') }}：
            </span>
            {{ partition.numbers_from }}<br>

            <span style="font-weight: bold;font-size: 1.1em;">
                <!-- 結尾： -->
                {{ $t('models.attributes.partitions.numbers_to') }}：
            </span>
            {{ partition.numbers_to }}<br>

            <span style="font-weight: bold;font-size: 1.1em;">
                <!-- 總數量： -->
                {{ $t('ui.pages.partitions.total_amount') }}：
            </span>
            {{ $store.getters[store_key+'number_with_commas'](partition.numbers_amount) }}<br>

            <span style="font-weight: bold;font-size: 1.1em;">
                <!-- 可用數量： -->
                {{ $t('ui.pages.partitions.available_quantity') }}：
            </span>
            {{ $store.getters[store_key+'number_with_commas'](partition.remaining_numbers) }}
        </td>
        <td>
            <div class="ui items">
                <router-link class="item" v-for="(child_partition, index) in partition.child_partitions"
                    :key="child_partition.identity"
                    :to="{
                        name: 'edit_partition',
                        params: {
                            partition_identity: child_partition.identity
                        }
                    }">
                    {{ index + 1 }}. {{ child_partition.name }}
                </router-link>
            </div>
        </td>
        <td>
            <router-link v-if="$store.getters[store_key+'current_customer'](partition)" :to="{name: 'customer', params: {customer_identity: $store.getters[store_key+'current_customer'](partition).identity}}">
                {{ $store.getters[store_key+'current_customer'](partition).company_short_name || $store.getters[store_key+'current_customer'](partition).identity }}
            </router-link>
            <div v-else>
                <!--
                    automatic_number 自動取號,
                    use_yourself 自用
                -->
                {{
                    partition.partition_type == "Auto"
                        ? $t('ui.pages.partitions.automatic_number')
                        : $t('ui.pages.partitions.use_yourself')
                }}
            </div>
        </td>
        <td>
            <div class="ui items" v-if="$store.getters[store_key+'current_customer'](partition)">
                <router-link class="item" v-for="(contract, index) in partition.contracts"
                    :key="contract.identity"
                    :to="{
                        name: 'provider_contract',
                        params: {
                            customer_identity: $store.getters[store_key+'current_customer'](partition).identity,
                            contract_identity: contract.identity
                        }
                    }">
                    {{ index + 1 }}. {{ contract.name }}
                </router-link>
            </div>
        </td>
        <td>
            <router-link v-if="$store.getters[store_key+'current_material'](partition)" :to="{name: 'edit_material', params: {material_identity: $store.getters[store_key+'current_material'](partition).identity}}">
                {{ $store.getters[store_key+'current_material'](partition).name }}
            </router-link>
        </td>
        <td>{{ partition.note }}</td>
        <td>
            <router-link :to="{name: 'edit_provider_partition', params: {partition_identity: partition.identity}}" class="ui basic green button">
                {{ $t('ui.general.edit') }}
            </router-link>

            <div v-if="!partition.is_deleting" @click.prevent="$parent.delete_partition(partition)" class="ui basic red button">
                {{ $t('ui.general.delete') }}
            </div>
            <div v-else class="ui basic red button">
                {{ $t('ui.general.deleteing') }}...
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    name: "PartitionRow",
    props: {
        partition: Object
    },
    data() {
        return {
            store_key: 'provider/partitions_module/'
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    computed: {
    },
    components: {
    }
}
</script>
